import { makeStyles, fade } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  hasValue: {
    '& .MuiInputBase-root': {
      color: theme.palette.primary.light,
      borderColor: fade(theme.palette.primary.main, 0.16),
      backgroundColor: theme.palette.primary.lighter,
    },
  },
}))

export default useStyles
